export const LEVEL_DESCRIPTIONS = {
  casual: "An easier crossword featuring familiar artists, songs, and Hip Hop history — and a few hard ones thrown in so you learn something.",
  golden_era: "A tougher challenge featuring deep cuts, obscure connections, and serious Hip Hop knowledge.",
};

export const PREMIUM_BENEFITS = [
  "Access to ALL New Jack and Triple OG puzzles",
  "Ad-free gameplay",
  "Full, replayable Puzzle Archive",
  "FREE letter hints",
  "FREE whole-word reveals",
];

export const BONUS_ONLY_NOTE = "All puzzle access includes regular New Jack and Triple OG puzzles and the Archive. Bonus-Only puzzles remain earned through the existing seven-day login reward system.";
